angular.module('previewBannerModule', []);
